import { useContext } from "react";
import { GraphIcon } from "@primer/octicons-react";
import {
  ActionList,
  ActionMenu,
  Box,
  PageLayout,
  useTheme,
} from "@primer/react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { appInfo } from "../../AppInfo";
import CmbCoSoRaw from "../../components/editor/cmb_coso";
import CmbNamHocRaw from "../../components/editor/cmb_namhoc";
import { coSoActionTypes } from "../../state/reducers/coSoReducer";
import { namHocActionTypes } from "../../state/reducers/namHocReducer";
import Button from "../../components/ui/button";
import UserPanel from "../../components/user-panel";
import { actions } from "../../state/actions/actionsWrapper";
import { RootState } from "../../state/reducers";
import { ILayoutContext, LayoutContext } from "../Layout";
import MenuGroup from "../menu-group";
import styles from "./Header.module.css";

const AppsIcon = () => {
  return (
    <img alt="apps" style={{ height: "16px" }} src="../../images/apps.png" />
  );
};
const VietNamIcon = () => {
  return (
    <img alt="vn" style={{ height: "16px" }} src="../../images/vietnam.png" />
  );
};
const EnglandIcon = () => {
  return (
    <img
      alt="en"
      style={{ height: "16px" }}
      src="../../images/united-kingdom.png"
    />
  );
};
const KoreanIcon = () => {
  return (
    <img
      alt="kr"
      style={{ height: "16px" }}
      src="../../images/south-korea.png"
    />
  );
};
const CmbCoSo: any = CmbCoSoRaw;
const CmbNamHoc: any = CmbNamHocRaw;
interface IHeaderProps {
  // onColorModeChanged: (colorMode: "day" | "night") => void
}
const Header = (props: IHeaderProps) => {
  const { colorMode } = useTheme();
  const { setHideSubNav } = useContext<ILayoutContext>(LayoutContext);
  const common = useSelector((state: RootState) => state.common);
  const dispatch = useDispatch();
  const { dm_truong_selected_id, nam_hoc } = useSelector(
    (x: RootState) => x.common
  );

  const { user_info } = useSelector((x: RootState) => x.auth);
  const logoUrl =
    user_info?.vender_logo ??
    "https://portal.1school.edu.vn/images/logo-white.sv";

  const LogoIcon = () => {
    const handleClick = () => {
      window.location.href = appInfo.homeURL;
    };

    return (
      <img
        alt="logo"
        style={{ height: "40px", borderRadius: "5px" }}
        src={logoUrl}
        onClick={handleClick}
      />
    );
  };
  return (
    <Box
      sx={{
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderBottomColor: "border.default",
        borderTopWidth: "1px",
        borderTopStyle: "solid",
        borderTopColor: "border.default",
        backgroundColor: "rgba(24, 45, 98, 0.2)",
      }}
    >
      <PageLayout sx={{ padding: 0 }} containerWidth="full">
        <Box
          style={{
            height: appInfo.headerHeight,
            display: "flex",
            width: "100%",
            alignItems: "center",
            backgroundColor: "#182D62",
          }}
          className={styles.header}
        >
          <Box
            className={styles.left}
            sx={{
              width: 250,
              pl: 4,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Link to={"../../home"}>
              <LogoIcon />
            </Link>
          </Box>
          <div
            className={styles.center}
            style={{
              flex: 1,
              height: 56,
              display: "flex",
              alignItems: "center",
            }}
          >
            <div className={styles.item}>
              <Link
                to={"../../home"}
                style={{ textDecoration: "none" }}
                onClick={() => {
                  if (setHideSubNav) setHideSubNav(true);
                }}
              >
                <Button text="Dashboard" leadingVisual={GraphIcon} />
              </Link>
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.item}>
              <CmbCoSo
                value={common.dm_coso_id > 0 ? common.dm_coso_id : undefined}
                onValueChanged={(value: number) => {
                  dispatch({ type: coSoActionTypes.CHANGE_SELECTED_ID, payload: value });
                  dispatch(
                    actions.common.changedValueHeaderComboboxCoSo(value)
                  );
                }}
              />
            </div>
            <div className={styles.item}>
              <CmbNamHoc
                value={nam_hoc}
                width="170px"
                onValueChanged={(value: string) => {
                  dispatch({ type: namHocActionTypes.CHANGE_SELECTED_ID, payload: value });
                  dispatch(
                    actions.common.changedValueHeaderComboboxNamHoc(value)
                  );
                }}
              />
            </div>
            <div className={styles.item}>
              <ActionMenu>
                <ActionMenu.Button
                  aria-label="Select field type"
                  leadingVisual={VietNamIcon}
                >
                  Tiếng Việt
                </ActionMenu.Button>
                <ActionMenu.Overlay width="auto">
                  <ActionList selectionVariant="single">
                    <ActionList.Item selected={true} onSelect={() => { }}>
                      <ActionList.LeadingVisual>
                        <VietNamIcon />
                      </ActionList.LeadingVisual>
                      Tiếng Việt
                    </ActionList.Item>
                    <ActionList.Item disabled>
                      <ActionList.LeadingVisual>
                        <EnglandIcon />
                      </ActionList.LeadingVisual>
                      English
                    </ActionList.Item>
                    <ActionList.Item disabled>
                      <ActionList.LeadingVisual>
                        <KoreanIcon />
                      </ActionList.LeadingVisual>
                      한국어
                    </ActionList.Item>
                  </ActionList>
                </ActionMenu.Overlay>
              </ActionMenu>
            </div>
            <div className={styles.item}>
              <UserPanel />
            </div>
          </div>
        </Box>
        <MenuGroup />
      </PageLayout>
    </Box>
  );
};

export default Header;
